import { find } from "lodash";
import styles from "./currency.module.css";

const DIRHAM_ICONS = {
  main: "/assets/icons/DirhamB.svg",
  sub: "/assets/icons/DirhamG.svg",
};

export function DirhamSymbol({ variant = "main", className = "", size = 14 }) {
  const src = variant === "main" ? DIRHAM_ICONS.main : DIRHAM_ICONS.sub;

  return (
    <span
      className={`${styles.dirhamIcon} ${className}`.trim()}
      aria-hidden="true"
    >
      {variant === "green" ? (
        <img
          src={src}
          alt=""
          width={size}
          height={size}
          style={{ width: size, height: size }}
          className={styles.dirhamIconGreen}
        />
      )
        : variant === "white" ? (
          <img
            src={src}
            alt=""
            width={size}
            height={size}
            style={{ width: size, height: size }}
            className={styles.dirhamIconWhite}
          />
        ) : (
          <img
            src={src}
            alt=""
            width={size}
            height={size}
            style={{ width: size, height: size }}
          />
        )}
    </span>
  );
}

export function getCurrencyLabel() {
  if (typeof window !== "undefined") {
    const pathname = window.location.pathname.toLowerCase();
    const isIndian = find(pathname.split("/"), (p) => p === "in");
    return isIndian ? "₹" : "AED";
  }

  return "₹";
}

export function getCurrencySymbol(variant = "main", size = 14, className = "") {
  // const { variant = "main", size = 14, className = "" } = options;

  if (typeof window !== "undefined") {
    const pathname = window.location.pathname.toLowerCase();
    const isIndian = find(pathname.split("/"), (p) => p === "in");
    return isIndian ? (
      "₹ "
    ) : (
      <DirhamSymbol variant={variant} size={size} className={className} />
    );
  }

  return "₹ ";
}
